import {
  Pais,
  Departamento,
  Localidad
} from '@rpe/registro-personas-empresas-lib';
import { DireccionGeograficaIDE } from '../entity-direcciones-geografica-ide/direcciones-geografica-ide.model';
import { LocalidadIDE } from '../entity-localidades-ide/entity-localidades-ide.model';

export interface DireccionGeograficaSet {
  paises: Pais[];
  departamentos: Departamento[];
  localidades: Localidad[];
  localidadesIDE: LocalidadIDE[];
  direccionesGeograficasIDE: DireccionGeograficaIDE[];
  direccionGeograficaIDEExacta: DireccionGeograficaIDE;
}

export function createEmptyDireccionGeograficaSet(): DireccionGeograficaSet {
  return {
    paises: null,
    departamentos: null,
    localidades: null,
    localidadesIDE: null,
    direccionesGeograficasIDE: null,
    direccionGeograficaIDEExacta: null
  };
}

export function createDireccionGeograficaSet(
  params: any
): DireccionGeograficaSet {
  return {
    ...createEmptyDireccionGeograficaSet(),
    ...params
  };
}
